import React from "react";
import { useNavigate } from "react-router-dom";
import { B2BLayout } from "../../components/b2b/B2BLayout";
import { IMG } from "../../lib/b2b";
import { ClipboardList, Wind, Search, DoorOpen, Camera, AlertTriangle, CalendarCheck, ArrowRight } from "lucide-react";

const Item = ({ icon: Icon, title, text }) => (
  <div className="flex gap-4 rounded-2xl border border-[#0B1F3A]/10 bg-white p-5">
    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#0E7C7B]/10 text-[#0E7C7B]"><Icon className="h-5 w-5" /></div>
    <div><h3 className="font-display text-base font-bold text-[#0B1F3A]">{title}</h3><p className="mt-1 text-sm text-[#0B1F3A]/60">{text}</p></div>
  </div>
);

export default function B2BWhatWeCheck() {
  const nav = useNavigate();
  return (
    <B2BLayout>
      <section className="mx-auto max-w-6xl px-5 py-12">
        <div className="grid items-center gap-8 lg:grid-cols-2">
          <div>
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-[#0B1F3A] sm:text-4xl">Cosa controlliamo</h1>
            <p className="mt-3 text-base text-[#0B1F3A]/70">Ogni visita segue una procedura ripetibile e documentata, pensata per anticipare le anomalie e tenere in ordine lo storico di ogni immobile.</p>
          </div>
          <img src={IMG.acWall} alt="Unità split da controllare" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-lg" />
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          <Item icon={ClipboardList} title="Inventario iniziale delle dotazioni" text="Censimento di arredi, impianti accessibili e dotazioni di ogni unità." />
          <Item icon={Wind} title="Pulizia filtri accessibili degli split inclusi" text="Manutenzione dei filtri raggiungibili degli split compresi nel piano." />
          <Item icon={Search} title="Controlli visivi e test non invasivi" text="Verifiche delle dotazioni concordate senza smontaggi o interventi invasivi." />
          <Item icon={DoorOpen} title="Verifica funzionale di arredi, infissi e smart lock" text="Test di funzionamento quando pertinente per l'immobile." />
          <Item icon={Camera} title="Report fotografico" text="Documentazione visiva dello stato rilevato durante la visita." />
          <Item icon={AlertTriangle} title="Segnalazione delle anomalie con priorità" text="Elenco delle criticità con livello di urgenza per decidere gli extra." />
          <Item icon={CalendarCheck} title="Calendario del controllo successivo" text="Pianificazione della visita successiva in base al piano." />
        </div>

        <div className="mt-8 rounded-3xl border border-[#F97316]/30 bg-[#F97316]/5 p-6 text-sm text-[#0B1F3A]/80">
          <p className="font-bold text-[#0B1F3A]">Un chiarimento importante</p>
          <p className="mt-2">I controlli visivi non sostituiscono manutenzioni obbligatorie, certificazioni o verifiche regolamentate degli impianti. Le attività specialistiche vengono gestite con soggetti abilitati quando richiesto. Il servizio non costituisce una certificazione di conformità dell'immobile.</p>
        </div>

        <div className="mt-8 text-center">
          <button data-testid="check-cta" onClick={() => nav("/contatti")} className="inline-flex items-center gap-2 rounded-full bg-[#F97316] px-6 py-3.5 font-bold text-white shadow-lg transition hover:brightness-110">Richiedi una proposta <ArrowRight className="h-5 w-5" /></button>
        </div>
      </section>
    </B2BLayout>
  );
}
